<template>
  <div class="event-details content-padding">
    <div>
      <list-item
        v-if="isVoterVerified"
        icon="account_circle"
        title="Member Info"
        :second-title="memberText"
      />
      <list-item
        icon="event"
        title="When"
        :second-title="date"
        :third-title="time"
      />
      <list-item icon="place" title="Where" :second-title="meetingLocation" />
      <list-item
        v-if="isAttending"
        icon="how_to_reg"
        title="Are you going?"
        second-title="Yes"
      />
      <download-item
        :is-closed="isClosed"
        :is-expired="isExpired"
        :display-options="displayOptions"
        :meeting-documents="meetingDocuments"
      />
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import {formatDate} from '@/vuex/helpers.js';
import ListItem from './EventDetailsListItem';
import DownloadItem from './DownloadListItem';

export default {
  name: 'EventDetails',
  components: {
    ListItem,
    DownloadItem
  },
  props: {
    displayOptions: {
      type: Object,
      default() {
        return {};
      }
    },
    meetingDate: {
      type: String,
      default: ''
    },
    meetingTimezone: {
      type: String,
      default: null
    },
    meetingLocation: {
      type: String,
      default: ''
    },
    meetingDocuments: {
      type: Array,
      default() {
        return [];
      }
    },
    isClosed: {
      type: Boolean,
      default: false
    },
    isExpired: {
      type: Boolean,
      default: false
    },
    isAttending: {
      type: Boolean,
      default: false
    },
    voter: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    // Use timezone specified in meeting options or default to Toronto
    timezone() {
      return this.meetingTimezone ? this.meetingTimezone : 'America/Toronto';
    },
    // Use date format in meeting options or default
    date() {
      const date = _.has(this.displayOptions, 'home.date_format.date')
        ? this.displayOptions.home.date_format.date
        : 'dddd, MMMM Do, YYYY';
      return formatDate(this.meetingDate, this.timezone, date);
    },
    // Use time format in meeting options or default
    time() {
      const time = _.has(this.displayOptions, 'home.date_format.time')
        ? this.displayOptions.home.date_format.time
        : 'h:mm a zz';
      return formatDate(this.meetingDate, this.timezone, time);
    },
    isVoterVerified() {
      return this.voter.isVerified;
    },
    memberText() {
      return this.isVoterVerified
        ? `${this.voter.name} (${this.voter.unit}) `
        : '';
    }
  }
};
</script>

<style scoped>
.event-details {
  width: 100%;
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/EventDetails.vue